var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueMultiselect',_vm._g(_vm._b({attrs:{"role":"combobox","placeholder":_vm.$attrs.placeholder},nativeOn:{"focus":function($event){return _vm.$emit('focus', $event)}},model:{value:(_vm.valueSync),callback:function ($$v) {_vm.valueSync=$$v},expression:"valueSync"}},'VueMultiselect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }